import preloader from '../../image/preloader.png'
import styles from './preloader.module.css'
export const Preloader = () =>{
    return(
        <div className={styles.preloader_connent}>
            <img src={preloader} className={styles.preloader_image}/> 
        </div>
    )
}